import water from '../placeholder.png';
import Navbar from './Navbar';

const App = () => {
    return (
        <div>
            <Navbar/>

            <header className="masthead bg-primary text-white text-center">
                <div className="container d-flex align-items-center flex-column">
                    <h1 className="masthead-heading text-uppercase mb-5">Shaurya Kala</h1>
                </div>
            </header>

            <section className="page-section portfolio mb-0" id="portfolio">
                <div className="container">
                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">This website was made with:</h2>
                    <br/>
                    <div className="row">
                        <div className="col-lg-12 ms-auto text-center"><p className="lead">HTML, CSS, Javascript, React JS, PHP, MySQL, Bootstrap, JQuery, and REST API calls</p></div>
                        <div className="col-lg-12 ms-auto text-center"><p className="lead">COMING SOON: Log-in with Google and Facebook (Google/Facebook authentication with Firebase)</p></div>

                    </div>
                </div>
            </section>

            <section className="page-section portfolio" id="portfolio">
                <div className="container">
                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Pictures</h2>
                    <br/>
                    <br/>
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4 mb-5">
                            <div className="portfolio-item mx-auto" data-bs-target="#portfolioModal1">
                                <img className="img-fluid" src={water} alt="..." />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 mb-5">"
                            <div className="portfolio-item mx-auto" data-bs-target="#portfolioModal2">
                                <a href="https://www.pisd.edu/site/Default.aspx?PageType=3&DomainID=8&PageID=1&ViewID=6446ee88-d30c-497e-9316-3f8874b3e108&FlexDataID=65531"><img className="img-fluid" src="BPA_1.jpg" alt="1st place at Nationals for Web Design" /></a>
                            </div>
                            <br/>
                            <a href="https://www.pisd.edu/site/Default.aspx?PageType=3&DomainID=8&PageID=1&ViewID=6446ee88-d30c-497e-9316-3f8874b3e108&FlexDataID=65531"><p style={{textAlign:'center'}}>1st place at Nationals for Web Design</p></a>
                        </div>
                        <div className="col-md-6 col-lg-4 mb-5">
                            <div className="portfolio-item mx-auto" data-bs-target="#portfolioModal3">
                                <img className="img-fluid" src={water} alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-section bg-primary text-white mb-0" id="about">
                <div className="container">
                    <h2 className="page-section-heading text-center text-uppercase text-white">About Me</h2>
                    <div className="divider-custom divider-light">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon"><i className="fas fa-star"></i></div>
                        <div className="divider-custom-line"></div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 ms-auto"><p className="lead">Hey there! I'm a computer science college student that's really into programming and gaming. I've created this website in my free time, check out the projects I've worked on by clicking on the top menu!</p></div>
                        <div className="col-lg-4 me-auto"><p className="lead">I'm looking for internships and other opportunities. If you'd like to get in touch, you can contact me below!</p></div>
                    </div>
                </div>
            </section>

            <section className="page-section" id="contact">
                <div className="container">
                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Contact Me</h2>
                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon"><i className="fas fa-star"></i></div>
                        <div className="divider-custom-line"></div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-7">
                            <form id="contactForm">
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="name" type="text" placeholder="Enter your name..." data-sb-validations="required" />
                                    <label htmlFor="name">Full name</label>
                                    <div className="invalid-feedback" data-sb-feedback="name:required">A name is required.</div>
                                </div>
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="email" type="email" placeholder="name@example.com" data-sb-validations="required,email" />
                                    <label htmlFor="email">Email address</label>
                                    <div className="invalid-feedback" data-sb-feedback="email:required">An email is required.</div>
                                    <div className="invalid-feedback" data-sb-feedback="email:email">Email is not valid.</div>
                                </div>
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="phone" type="tel" placeholder="(123) 456-7890" data-sb-validations="required" />
                                    <label htmlFor="phone">Phone number</label>
                                    <div className="invalid-feedback" data-sb-feedback="phone:required">A phone number is required.</div>
                                </div>
                                <div className="form-floating mb-3">
                                    <textarea className="form-control" id="message" type="text" placeholder="Enter your message here..." style={{height: "10rem"}} data-sb-validations="required"></textarea>
                                    <label htmlFor="message">Message</label>
                                    <div className="invalid-feedback" data-sb-feedback="message:required">A message is required.</div>
                                </div>
                                <div className="d-none" id="submitSuccessMessage">
                                    <div className="text-center mb-3">
                                        <div className="fw-bolder">Form submission successful!</div>
                                    </div>
                                </div>
                                <div className="d-none" id="submitErrorMessage"><div className="text-center text-danger mb-3">Error sending message!</div></div>
                                <button className="btn btn-primary btn-xl disabled" id="submitButton" type="submit">Send</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="page-section portfolio mb-0" id="portfolio">
                <div className="container">
                    <h3 className="page-section-heading text-center text-uppercase text-secondary mb-0">How the form works:</h3>
                    <br/>
                    <div className="row">
                        <div className="col-lg-12 ms-auto text-center"><p className="lead">The data is submitted to a server-side script (PHP) which processes the form data.</p></div>
                        <div className="col-lg-12 ms-auto text-center"><p className="lead">Right now, it submits this data to a secure MySQL database for me to view later, but I'm planning to add email support.</p></div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default App;